<template>
  <v-container fluid>
    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>

    <div class="d-flex flex-column justify-center align-center">
      <div class="col-12 col-lg-6">
        <v-card tile flat>
          <v-card-title class="d-flex justify-center align-center text-center">
            Goed nieuws: jij bent geregistreerd bij Move To Happiness!
          </v-card-title>
          <v-card-text class="text-center">
            <p>
              <br/>
              <br/>
              Jouw persoonlijke happiness journey kan binnenkort van start gaan, want vanaf {{ $moment(endDate).format('DD/MM/YYYY, HHumm') }} heb jij toegang tot de volledige bibliotheek met 4-wekenprogramma’s.
              <br/>
              <br/>
              Benieuwd met welke programma’s je aan de slag zal kunnen? Check nu al het startpakket dat je laatst ontving of download de info <a href="https://movetohappiness.com/wp-content/uploads/2022/04/Startgids-Move-To-Happiness.pdf" target="_blank">hier</a>.
              <br/>
              <br/>
              Make your move!
            </p>
            <p></p>
          </v-card-text>
        </v-card>
      </div>
      
      <div class="col-12 col-lg-6">
        <div class="d-flex justify-space-between align-center">
          <div class="col-4 pa-0 pr-2">
            <v-card tile flat class="py-6">
              <v-card-text>
                <h1 class="text-center">{{ days }}</h1>
              </v-card-text>
              <v-card-text>
                <h3 class="text-center text-uppercase">Dagen</h3>
              </v-card-text>
            </v-card>
          </div>
          
          <div class="col-4 pa-0 px-1">
            <v-card tile flat class="py-6">
              <v-card-text>
                <h1 class="text-center">{{ hours }}</h1>
              </v-card-text>
              <v-card-text>
                <h3 class="text-center text-uppercase">Uren</h3>
              </v-card-text>
            </v-card>
          </div>
          
          <div class="col-4 pa-0 pl-2">
            <v-card tile flat class="py-6">
              <v-card-text>
                <h1 class="text-center">{{ minutes }}</h1>
              </v-card-text>
              <v-card-text>
                <h3 class="text-center text-uppercase">Minuten</h3>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </div>
    </div>

  </v-container>
</template>

<script>
import i18n from "@/services/i18n";

export default {
  i18n: i18n,
  name: "m2h-p1",
  props: ['countdown'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      window: {
        width: 0,
        height: 0
      },
      endDate: null,
      days: null,
      hours: null,
      minutes: null,
      isEnded: null,
    }
  },
  mounted() {
    this.endDate = new Date(this.countdown);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.tick()
    this.timer = setInterval(this.tick.bind(this), 1000)
  },
  
  unmounted(){
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },

    updateRemaining (distance) {
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    },

    tick () {
      const currentTime = new Date()
      const distance = Math.max(this.endDate - currentTime, 0)
      this.updateRemaining(distance)

      if (distance === 0) {
        clearInterval(this.timer)
        this.isEnded = true
      }
    }
  },
  
  destroy () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
</style>
